export default __webpack_public_path__ + "static/media/ES.fd060ad5.png";